import React from "react";
function Header() {
  return (
    <header>
      <a href="/"><h1>SHAPE AI</h1></a>
    </header>
  );
}

export default Header;
